import React, { useEffect, useState } from 'react';
import { Table, Button, Input, Spin, Modal } from 'antd';
import { collection, getDocs } from 'firebase/firestore';
import { useFirebase } from '../FirebaseContext';
import { MagnifyingGlass } from '@phosphor-icons/react';
import UserProfile from './UserProfile';
import './Kierowcy.css'; // reuse same styles

const Uzytkownicy = () => {
  const { currentFirebase } = useFirebase();
  const firestoreInstance = currentFirebase.firestore;

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        // Без serverside orderBy: Firestore исключает документы БЕЗ поля driverId
        // (а это как раз новые регистрации) — забираем всех и сортируем на клиенте.
        const snap = await getDocs(collection(firestoreInstance, 'users'));
        const list = snap.docs.map(doc => ({
          id: doc.id,
          firstName: doc.data().firstName,
          lastName: doc.data().lastName,
          email: doc.data().email,
          status: doc.data().status,
          driverId: doc.data().driverId,
          signedUZ: doc.data().signedUZ ? 'Tak' : 'Nie',
        }));
        // Новые (без driverId) — наверх, остальные по driverId (числовой порядок).
        list.sort((a, b) => {
          if (!a.driverId && !b.driverId) return 0;
          if (!a.driverId) return -1;
          if (!b.driverId) return 1;
          return String(a.driverId).localeCompare(String(b.driverId), undefined, { numeric: true });
        });
        setUsers(list);
      } catch (error) {
        console.error('Error fetching users:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, [firestoreInstance]);

  const filteredUsers = users.filter(u => {
    const text = `${u.firstName} ${u.lastName} ${u.email} ${u.status}`.toLowerCase();
    return text.includes(searchQuery.toLowerCase());
  });

  const columns = [
    {
      title: 'Imię i Nazwisko',
      key: 'name',
      sorter: (a, b) => `${a.lastName}`.localeCompare(`${b.lastName}`),
      render: (_, r) => <span style={{ fontWeight: 500 }}>{r.firstName} {r.lastName}</span>,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: (e) => <span style={{ color: '#6b7280', fontSize: 12 }}>{e}</span>,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 180,
      render: (s) => {
        const cls = s === 'Zweryfikowany' ? 'wyd-status wyd-status-ok' : 'wyd-status wyd-status-default';
        return <span className={cls}>{s || '-'}</span>;
      },
    },
    {
      title: 'UZ',
      dataIndex: 'signedUZ',
      key: 'signedUZ',
      width: 60,
      align: 'center',
    },
    {
      title: '',
      key: 'profile',
      width: 100,
      align: 'center',
      render: (_, r) => (
        <Button size="small" onClick={() => { setSelectedUser(r.id); setIsModalVisible(true); }}>
          Profil
        </Button>
      ),
    },
  ];

  return (
    <div>
      <div className="kier-toolbar">
        <Input
          prefix={<MagnifyingGlass size={16} color="#9ca3af" />}
          placeholder="Szukaj użytkownika..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          allowClear
          style={{ flex: 1 }}
        />
      </div>

      <Table
        className="kier-table"
        columns={columns}
        dataSource={filteredUsers}
        rowKey="id"
        loading={loading}
        scroll={{ x: 'max-content' }}
        size="middle"
        pagination={{
          pageSize: 20,
          showSizeChanger: true,
          pageSizeOptions: ['15', '25', '50'],
          showTotal: (total, range) => `${range[0]}–${range[1]} z ${total}`,
          size: 'small',
        }}
      />

      <Modal
        title="Profil użytkownika"
        open={isModalVisible}
        onCancel={() => { setIsModalVisible(false); setSelectedUser(null); }}
        footer={null}
        width={800}
        centered
      >
        {selectedUser && <UserProfile userId={selectedUser} />}
      </Modal>
    </div>
  );
};

export default Uzytkownicy;
